<template>
  <div id="app">
    <!-- <tel v-if="pathNameList.indexOf(pathName) != -1"></tel> -->
    <router-view v-if="isRouterAlive" />
  </div>
</template>

<script>
import "./app.css";
export default {
  name: 'app',
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      pathNameList: ['home'],
      isRouterAlive: true
    }
  },
  computed: {
    pathName() {
      return this.$route.name
    },
    hasLogin() {
      return sessionStorage.getItem("loginData");
    },
  },
  mounted() {
    // if (!this.hasLogin) {
    //   console.log(window.location.pathname)
    //   if (!window.location.pathname.includes('login')) {
    //     this.$message({
    //       message: this.$t('transaction.pleaseLogin'),
    //       type: 'error',
    //       duration: 1500,
    //       onClose: () => {
    //         window.location.replace('/login')
    //       }
    //     });
    //   }

    // }
  },
  methods: {
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function() {
        this.isRouterAlive = true
      })
    }
  }
}
</script>

<style lang="scss">
#app {
  font-family: "Alibaba PuHuiTi 2";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
body {
  margin: 0;
}
img {
  width: 100%;
  display: block;
}
.el-input {
  .el-input__inner:focus {
    border-color: #23af91;
  }
  .el-input__inner {
    background-color: #fafafa;
    height: 45px;
    line-height: 45px;
    // border: 1px solid #313039;
  }
}
.el-select {
  .is-focus {
    .el-input__inner {
      border-color: #23af91 !important;
    }
  }
}
.el-table {
  .el-table__empty-block {
    background-color: #fafafa;
  }
}
.el-dialog {
  .el-dialog__header {
    background-color: #fafafa;
  }
}
/* 滚动条样式*/
::-webkit-scrollbar {
  //先改变的滚动条宽度
  width: 0px;
  height: 10px;
}

::-webkit-scrollbar-track {
  //再改变的滚动条轨道颜色
  background: #2a3042;
  border-radius: 5px;
}

::-webkit-scrollbar-thumb {
  //最后改变的滚动条滑轨相关的样式
  background: rgb(120, 120, 120);
  border-radius: 5px;
}
</style>
